export { HostedFrame } from './HostedFrame';
export type {
  HostedFrameMessageEvent,
  HostedFrameRef,
} from './HostedFrame.types';
